<div class="footer">
  <div class="footer__left">
    <span>Suivez nous</span>
    <a href="https://instagram.com/letrot/" target="_blank">
      <mat-icon class="icon" svgIcon="instagram"></mat-icon>
    </a>
    <a href="https://www.facebook.com/Le.Trot" target="_blank">
      <mat-icon class="icon" svgIcon="facebook"></mat-icon>
    </a>
    <a href="https://twitter.com/LeTrot" target="_blank">
      <mat-icon class="icon" svgIcon="twitter"></mat-icon>
    </a>
    <a href="https://www.youtube.com/channel/UCIs5NdZnbQLo0GoJTgVoEBQ" target="_blank">
      <mat-icon class="icon" svgIcon="youtube"></mat-icon>
    </a>
  </div>
  <div class="footer__right">
    <a href="https://www.letrot.com/contact">Nous contacter</a>
    <a [href]="getCguUrl()" download="Petites_annonces_CGU.pdf">Conditions générales d'utilisation</a>
  </div>
</div>
